import { render, staticRenderFns } from "./imageUpTextDown.vue?vue&type=template&id=0a708bcb&scoped=true"
import script from "./imageUpTextDown.vue?vue&type=script&lang=js"
export * from "./imageUpTextDown.vue?vue&type=script&lang=js"
import style0 from "./imageUpTextDown.vue?vue&type=style&index=0&id=0a708bcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a708bcb",
  null
  
)

export default component.exports